import { render, staticRenderFns } from "./commonFormInput.vue?vue&type=template&id=fc68fd1c&scoped=true"
import script from "./commonFormInput.vue?vue&type=script&lang=js"
export * from "./commonFormInput.vue?vue&type=script&lang=js"
import style0 from "./commonFormInput.vue?vue&type=style&index=0&id=fc68fd1c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc68fd1c",
  null
  
)

export default component.exports